import { useEffect, useRef, useState } from "react";
import { serverFetch } from "../../../server";
import { Button, message, Table, Checkbox } from "antd";
import MessagePattern from "./message-pattern";
import { getMessagePatternVidName } from "../../../extensions/helper";
import { useSelector } from "react-redux";
import { RefreshButton } from "../../../extensions/design";

const MessagePatterns = () => {
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);
  const [editId, setEditId] = useState(null);
  const divRef = useRef(null);
  const user = useSelector((s) => s.user);

  const getData = () => {
    setLoading(true);
    serverFetch("MessagePattern")
      .then(data => {
        setItems(data);
        setLoading(false);
      })
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      });
  };

  useEffect(getData, []);

  const columns = [
    { title: "#", dataIndex: "id", width: 60 },
    { title: "Название", dataIndex: "name", width: 300 },
    { title: "Вид", dataIndex: "vid", width: 250, render: getMessagePatternVidName },
    { title: "Срок (дней)", dataIndex: "srok", width: 100 },
    { title: "Активен", dataIndex: "active", width: 100, render: (val) => <Checkbox checked={val} disabled /> },
  ];

  const onClose = (refresh) => {
    setEditId(null);
    refresh && getData();
  };

  const headerSize = divRef.current?.querySelector('.ant-table-thead')?.offsetHeight ?? 0;
  const tableHeight = divRef.current ? (document.documentElement.offsetHeight - headerSize - divRef.current.getBoundingClientRect().top - window.scrollY - 1) : 0;

  return (
    <div className="sport-form-content">
      <div className="sport-form-title">
        {user.isAdmin && (
          <Button onClick={() => setEditId(0)} className="search-btn">
            Новый
          </Button>
        )}
        <RefreshButton onClick={getData} />
      </div>
      <div ref={divRef} style={{ flex: 1 }}>
        <Table
          dataSource={items}
          columns={columns}
          loading={loading}
          rowKey="id"
          size="small"
          pagination={false}
          scroll={{ y: tableHeight }}
          onRow={(record) => ({ 
            onClick: () => {
              if (user.isAdmin) {
                setEditId(record.id);
              }
            }
          })}
        />
      </div>
      {editId != null && <MessagePattern id={editId} onClose={onClose} />}
    </div>
  );
};

export default MessagePatterns;
